export default __webpack_public_path__ + "static/media/07__o_0.0084dfce.jpg";